var _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_89_1404)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.893433,
    y: 0.930664,
    width: 30.4228,
    height: 30.4026,
    rx: 5,
    fill: "#1E1E1E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4706 12.7235C23.4619 12.0389 23.3397 11.3611 23.1094 10.7205C22.9098 10.1801 22.6048 9.68928 22.2141 9.27948C21.8233 8.86969 21.3554 8.54987 20.8401 8.34049C20.2371 8.10308 19.6001 7.97471 18.9561 7.96085C18.127 7.92198 17.8641 7.91113 15.7594 7.91113C13.6547 7.91113 13.385 7.91113 12.5619 7.96085C11.9182 7.97482 11.2814 8.10318 10.6787 8.34049C10.1633 8.54973 9.69532 8.86949 9.30455 9.27931C8.91379 9.68912 8.6089 10.18 8.40939 10.7205C8.18257 11.3524 8.06044 12.0204 8.04826 12.6955C8.0112 13.5659 8 13.8416 8 16.0489C8 18.2563 8 18.5383 8.04826 19.4024C8.06119 20.0785 8.18272 20.7456 8.40939 21.3792C8.60924 21.9196 8.91435 22.4102 9.30525 22.8199C9.69614 23.2295 10.1642 23.5491 10.6796 23.7583C11.2806 24.0053 11.9175 24.1428 12.5627 24.1651C13.3927 24.2039 13.6556 24.2157 15.7603 24.2157C17.865 24.2157 18.1347 24.2157 18.9578 24.1651C19.6018 24.1518 20.2389 24.0237 20.8419 23.7863C21.357 23.5767 21.8248 23.2568 22.2155 22.847C22.6062 22.4373 22.9113 21.9466 23.1112 21.4064C23.3378 20.7736 23.4593 20.1066 23.4723 19.4295C23.5093 18.56 23.5205 18.2843 23.5205 16.0761C23.5188 13.8687 23.5188 13.5885 23.4706 12.7235ZM15.7542 20.2232C13.553 20.2232 11.7698 18.353 11.7698 16.0444C11.7698 13.7359 13.553 11.8657 15.7542 11.8657C16.811 11.8657 17.8244 12.306 18.5716 13.0896C19.3189 13.8733 19.7387 14.9362 19.7387 16.0444C19.7387 17.1527 19.3189 18.2156 18.5716 18.9992C17.8244 19.7829 16.811 20.2232 15.7542 20.2232ZM19.8972 12.6855C19.3827 12.6855 18.9681 12.2499 18.9681 11.7111C18.9681 11.5832 18.9922 11.4566 19.0388 11.3384C19.0855 11.2202 19.1539 11.1129 19.2401 11.0224C19.3264 10.932 19.4288 10.8603 19.5414 10.8113C19.6541 10.7624 19.7749 10.7372 19.8968 10.7372C20.0188 10.7372 20.1395 10.7624 20.2522 10.8113C20.3649 10.8603 20.4672 10.932 20.5535 11.0224C20.6397 11.1129 20.7081 11.2202 20.7548 11.3384C20.8015 11.4566 20.8255 11.5832 20.8255 11.7111C20.8255 12.2499 20.4101 12.6855 19.8972 12.6855Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7548 18.7589C17.1843 18.7589 18.343 17.5436 18.343 16.0445C18.343 14.5454 17.1843 13.3301 15.7548 13.3301C14.3254 13.3301 13.1666 14.5454 13.1666 16.0445C13.1666 17.5436 14.3254 18.7589 15.7548 18.7589Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_89_1404",
    x: -39.1066,
    y: -39.0693,
    width: 110.423,
    height: 110.403,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_89_1404"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_89_1404",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/Instagram Icon.2d542e079d733445c5502c82fd2ec42e.svg";
export { ForwardRef as ReactComponent };